<template>
  <div class="body">
    <div class="title">
      彩票发放
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ticketWelfare' }">
            彩票发放
          </el-breadcrumb-item>

          <el-breadcrumb-item>
            {{ $route.query.id ? "修改" : "添加" }}活动
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div style="margin: -20px 0 20px">
      <el-button size="mini" @click="$router.back()">返回</el-button>
    </div>

    <el-card>
      <el-form
        ref="form"
        :model="form"
        label-width="140px"
        :label-position="labelPosition"
      >
        <el-form-item label="活动标题" label-width="10%" prop="title">
          <el-input
            v-model="form.title"
            style="width: 50%"
            placeholder="输入标题"
          ></el-input>
        </el-form-item>

        <el-form-item label="领取时间" label-width="10%" prop="s_time">
          <el-date-picker
            v-model="form.s_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.e_time"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="线下兑换截止时间" label-width="10%" prop="s_date">
          <el-input
            v-model="form.r_time"
            placeholder="线下兑换截止时间"
            style="width: 50%"
          ></el-input>
          <div class="tip" style="color: red;">该时间仅提醒用户，无实际功能影响。</div>
        </el-form-item>
        <template v-if="!form.id">
          <el-form-item label="添加获奖名单" label-width="10%" prop="s_date">
            <NoImageFileUpload
              ref="noImageFileUploadRef"
              name="file"
              :anthorData="{ id: 'excel' }"
              :uploadedList.sync="form.excel"
              :uploadMaxLen="1"
              tip=""
              successTip="获奖名单"
              action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_excel"
            />
            <el-button type="text" @click="handleDownLoad">
              <i class="el-icon-download el-icon--right"></i>
              模板下载
            </el-button>
          </el-form-item>
        </template>
      </el-form>
      <el-button type="primary" @click="handleCommit">保存</el-button>
    </el-card>
  </div>
</template>

<script>
import NoImageFileUpload from "@/components/NoImageFileUpload/excel.vue";
import { cloneDeep } from "lodash";
import dayjs from "dayjs";
import {
  getLotteryActivityView,
  addLotteryActivity,
  editLotteryActivity,
} from "@/api/ticketWelfare";

export default {
  name: "TicketWelfareEdit",
  components: { NoImageFileUpload },
  data() {
    return {
      form: {
        title: "",
        excel: [],
      },
      token: sessionStorage.getItem("token"),
      labelPosition: "left",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query.id) {
        getLotteryActivityView({
          id: this.$route.query.id,
        }).then((resp) => {
          let data = resp.data.data;
          data.s_time = dayjs(new Date(data.s_time * 1000)).format(
            "YYYY-MM-DD hh:mm:ss"
          );
          data.e_time = dayjs(new Date(data.e_time * 1000)).format(
            "YYYY-MM-DD hh:mm:ss"
          );
          data.excel = (data.file || "").split(",");
          this.form = data;
        });
      }
    },
    async handleCommit() {
      const confirmData = cloneDeep(this.form);
      confirmData.file = confirmData.excel.join(",");
      const resp = confirmData.id
        ? await editLotteryActivity(confirmData)
        : await addLotteryActivity(confirmData);
      // console.log("_resp", resp);
      if (resp.data.result == 1) {
        this.$message({
          message: resp.data.msg,
          type: "success",
          duration: "2000",
        });

        setTimeout(() => {
          this.$router.push("/ticketWelfare");
        }, 2000);
      } else {
        this.$message({
          message: resp.data.msg,
          type: "error",
          duration: "2000",
        });
      }
    },
    handleDownLoad() {
      const downloadElement = document.createElement("a");
      const href = `https://app.yundongm.cn/statics-web/admin/名单模板.xls`;
      downloadElement.href = href;
      downloadElement.target = '_blank';
      downloadElement.download = `名单模板`;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
    },
  },
};
</script>

<style scoped lang="less">
.imgbox {
  width: 188px;
  height: 188px;
  opacity: 1;
  background: rgba(0, 0, 0, 0);
  border-radius: 5px;
  position: relative;
  .imgs {
    width: 100%;
    height: 100%;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    opacity: 1;
    background: #e54848;
    border-radius: 50%;
  }
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
}
</style>
